"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import {
  Component
} from "vue-property-decorator";
import { ControllerComponent } from "@/components/core";
let BatchOperate = class extends ControllerComponent {
  clear() {
    this.$emit("closeBatch");
  }
  // clear(){
  //   this.$controller.queryKeyword = "";
  // }
  // @Debounce(800)
  // public searchChange(){
  //     const _keyword = _.get(this.$query,'keyword');
  //     this.$query.clear();
  //     _.set(this.$query,'keyword',_keyword)
  //     this.$emit('search',this.$query);
  // }
};
BatchOperate = __decorateClass([
  Component({
    components: {}
  })
], BatchOperate);
export {
  BatchOperate as default
};
